import React, { forwardRef } from 'react';
import { IDatePicker } from '../HBDatepicker/HBDatepicker.types';
import { useBuildTestIdInternal } from '../../hooks/useBuildTestIdInternal';
import { MustIncludeOneOfBasicTestIdWithIdProps } from '../common/internal/test-id.types';
import HBDatepickerBase from './HBDatepickerBase';
import { DatePickerStyled } from './HBDatepicker.styles';
import styled from 'styled-components';
import CustomHeader from './CustomHeader';
import { ReactDatePickerCustomHeaderProps } from 'react-datepicker';

const HBDatepickerMonthYear = forwardRef<
    any,
    IDatePicker & MustIncludeOneOfBasicTestIdWithIdProps
>((props, ref) => {
    const {
        id,
        testIdName,
        testId,
        customTheme,
        hasError,
        datepickerType = 'month'
    } = props;

    const datepickerTypeProp =
        datepickerType === 'month'
            ? { showMonthYearPicker: true }
            : { showYearPicker: true };

    const renderCustomHeader = ({
        decreaseYear,
        increaseYear,
        date,
        ...rest
    }: ReactDatePickerCustomHeaderProps) => (
        <CustomHeader
            decrease={decreaseYear}
            increase={increaseYear}
            date={date}
            viewType={datepickerType}
            {...rest}
        />
    );

    const finalTestId = useBuildTestIdInternal({
        testId,
        identifier: testIdName || id,
        suffix: 'wrapper',
        componentName: 'HBDatepickerMonthYear'
    });

    return (
        <Wrapper
            data-testid={finalTestId}
            customTheme={customTheme}
            hasError={hasError}
        >
            <HBDatepickerBase
                ref={ref}
                {...props}
                {...datepickerTypeProp}
                renderCustomHeader={renderCustomHeader}
            />
        </Wrapper>
    );
});

export default HBDatepickerMonthYear;

const Wrapper = styled(DatePickerStyled)``;
